// extracted by mini-css-extract-plugin
export default {"txhd":"TopSection_txhd__q7cMb","txtext":"TopSection_txtext__31zoA"};